import React from "react";
import { Link, useLocation } from "react-router-dom";
import { IconCreditCard, IconPieChart } from "../common/WireframeIcons";

interface AnalysisSubnavProps {
  mode: "accounts" | "cards";
}

export default function AnalysisSubnav({ mode }: AnalysisSubnavProps) {
  const location = useLocation();

  const tabs = [
    { key: "accounts" as const, label: "Análisis cuentas", path: "/dashboard/analisis" },
    { key: "cards" as const, label: "Desglose de gastos en tarjetas", path: "/dashboard/analisis/tarjetas" },
  ];

  return (
    <div className="analysis-subnav" role="tablist" aria-label="Submenú de análisis">
      {tabs.map(tab => {
        const active = mode === tab.key || location.pathname === tab.path;
        return (
          <Link
            key={tab.path}
            to={tab.path}
            className={`analysis-subnav-link${active ? " is-active" : ""}`}
            role="tab"
            aria-selected={active}
          >
            {tab.key === "accounts" ? <IconPieChart className="w-4 h-4" /> : <IconCreditCard className="w-4 h-4" />}
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
